import React from "react"
import {connect} from "react-redux"

import QuantityActions from '../ducks/quantity/actions'
import WidgetActions from '../ducks/widget/actions'
import { getProp } from '../ducks/widget/selectors'
import {mathTextStyle} from './styles'


class EqText extends React.Component {
	render(){
		return <span style={{...mathTextStyle}} >{this.props.text}</span>
	}
}

function mapStateToProps(state, props) {
	return {}// needed?
}

function mapDispatchToProps(dispatch) {
	return {
		setHighlight:(name, value) => {
			dispatch(QuantityActions.setHighlight(name, value))
		},
		setActive:(name, value) => {
			dispatch(WidgetActions.setActive(name, value))
		},
		setPlay:(name, value) => {
			dispatch(QuantityActions.setPlay(name, value))
		}
	};
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EqText);



// WEBPACK FOOTER //
// ./dev/components/EqText.jsx